module.exports = __webpack_public_path__ + "img/icon-vot-resultsetting.9dbbd153.png";